import * as _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import {
  addProfileTrigger,
  changeProfileTriggerPosition,
  editProfileTrigger,
  listProfileTriggerByProfileId,
  readProfileTrigger,
  removeProfileTrigger,
} from "./thunkAction";

const initialState = {
  triggers: [],
  trigger: {},
  loading: false,
  error: null,
  isLoadingAddProfileTrigger: false,
  isLoadingChangeProfileTriggerPosition: false,
  addProfileTriggerError: null,
};

const profileTriggerSlice = createSlice({
  name: "profileTriggerManage",
  initialState,
  reducers: {
    clearProfileTrigger(state) {
      state.trigger = {};
    },
    resetProfileError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // listProfileTriggerByProfileId
      .addCase(listProfileTriggerByProfileId.pending, (state) => {
        state.loading = true;
      })
      .addCase(listProfileTriggerByProfileId.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.triggers = _.get(action, "payload", []);
      })
      .addCase(listProfileTriggerByProfileId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // addProfileTrigger
      .addCase(addProfileTrigger.pending, (state) => {
        state.isLoadingAddProfileTrigger = true;
        state.addProfileTriggerError = null;
      })
      .addCase(addProfileTrigger.fulfilled, (state, action) => {
        state.isLoadingAddProfileTrigger = false;
        state.trigger = _.get(action, "payload", {});
      })
      .addCase(addProfileTrigger.rejected, (state, action) => {
        state.isLoadingAddProfileTrigger = false;
        state.addProfileTriggerError = action.payload;
      })
      // editProfileTrigger
      .addCase(editProfileTrigger.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editProfileTrigger.fulfilled, (state, action) => {
        state.loading = false;
        state.trigger = _.get(action, "payload", {});
      })
      .addCase(editProfileTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       // changeProfileTriggerPosition
      .addCase(changeProfileTriggerPosition.pending, (state) => {
        state.isLoadingChangeProfileTriggerPosition = true;
        state.error = null;
      })
      .addCase(changeProfileTriggerPosition.fulfilled, (state, action) => {
        state.isLoadingChangeProfileTriggerPosition = false;
        state.trigger = _.get(action, "payload", {});
      })
      .addCase(changeProfileTriggerPosition.rejected, (state, action) => {
        state.isLoadingChangeProfileTriggerPosition = false;
        state.error = action.payload;
      })
      // removeProfileTrigger
      .addCase(removeProfileTrigger.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeProfileTrigger.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(removeProfileTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // readProfileTrigger
      .addCase(readProfileTrigger.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(readProfileTrigger.fulfilled, (state, action) => {
        state.loading = false;
        state.trigger = _.get(action, "payload", {});
      })
      .addCase(readProfileTrigger.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const profileTriggerReducer = profileTriggerSlice.reducer;

export const profileTriggerAction = profileTriggerSlice.actions;
